import { useEffect, useRef, useState } from 'react';

const goodsImages = [
  {
    src: "https://www.irinomiyu-uuu.com/img/goods01_b7fe86f3deb0b30.png",
    alt: "グッズラインナップ - 8種類のグッズ写真"
  }
];

interface GoodsProps {
  onImageClick: (imageUrl: string) => void;
}

export default function Goods({ onImageClick }: GoodsProps) {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="goods"
      className={`py-20 px-4 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#fcb122] px-8 md:px-12 py-3 md:py-4 shadow-[0_0_40px_#fcb122]">
            <h2 className="text-3xl md:text-5xl text-[#0a0a0a] font-bold">GOODS</h2>
          </div>
        </div>

        {/* グッズラインナップ */}
        <div className="mb-12 bg-gradient-to-r from-[#1a1a3e] to-[#2a2a4e] border-2 border-[#fcb122]/50 p-6 md:p-8">
          <h3 className="text-xl md:text-2xl text-[#fcb122] font-bold mb-6 text-center">
            グッズラインナップ
          </h3>

          {/* グッズ画像 */}
          <div className="mb-8 flex justify-center">
            <img
              src={goodsImages[0].src}
              alt={goodsImages[0].alt}
              className="w-full max-w-md md:max-w-lg h-auto rounded-lg md:cursor-pointer md:hover:opacity-90 transition-opacity duration-300 md:hover:shadow-[0_0_20px_#fcb122]"
              onClick={() => {
                if (window.innerWidth >= 768) {
                  onImageClick(goodsImages[0].src);
                }
              }}
            />
          </div>

          {/* 事前通販対象 */}
          <div className="mb-8">
            <h3 className="text-base md:text-lg font-bold mb-4 text-[#1ef99d] border-b-2 border-[#1ef99d] pb-2">
              ＜事前通販対象＞
            </h3>
            <div className="space-y-3">
              <div>
                <div className="flex items-start gap-3">
                  <span className="text-xs md:text-sm">・コロミユぬいキー</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                    ¥3,000
                  </span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※全長約15cm</p>
              </div>
              
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">
                    ・使いやすいメッシュバック（ブラック・カーキ）全2種
                  </span>
                  <span className="md:hidden text-xs">
                    ・使いやすいメッシュバック<br />
                    （ブラック・カーキ）全2種
                  </span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                    各¥3,500
                  </span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※高さ：35cm/袋口幅：43cm/底幅：30cm</p>
              </div>
              
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">
                    ・ツアーT（ホワイト・ネイビー）全2種
                  </span>
                  <span className="md:hidden text-xs">
                    ・ツアーT<br />
                    （ホワイト・ネイビー）全2種
                  </span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                    各¥4,000
                  </span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">
                  ※「Mサイズ」身丈：69cm/身幅：52cm/肩幅：46cm/袖丈：20cm<br />
                  ※「Lサイズ」身丈：73cm/身幅：55cm/肩幅：50cm/袖丈：22cm
                </p>
              </div>
              
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">
                    ・どこでもシールセット（5枚）全15種/ランダム
                  </span>
                  <span className="md:hidden text-xs">
                    ・どこでもシールセット<br />
                    （5枚）全15種/ランダム
                  </span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                    ¥800
                  </span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※70～78mm×34～63mm</p>
              </div>
              
              <div>
                <div className="flex items-start gap-3">
                  <span className="hidden md:inline text-xs md:text-sm">
                    ・MOKU×UUUコラボタオル（ネイビー）
                  </span>
                  <span className="md:hidden text-xs">
                    ・MOKU×UUUコラボタオル<br />
                    （ネイビー）
                  </span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                    ¥1,500
                  </span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※33cm×100cm</p>
              </div>
              
              <div>
                <div className="flex items-start gap-3">
                  <span className="text-xs md:text-sm">・オシャレラグ</span>
                  <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                    ¥12,000
                  </span>
                </div>
                <p className="text-[10px] md:text-xs text-white/50 ml-3 mt-1">※本商品のみの個別会計・個別配送となります。</p>
              </div>
            </div>
          </div>

          {/* 会場販売 */}
          <div className="mb-8">
            <h3 className="text-base md:text-lg font-bold mb-4 text-[#fc457e] border-b-2 border-[#fc457e] pb-2">
              ＜会場販売＞
            </h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <span className="text-xs md:text-sm">・UUUスマートジャージ</span>
                <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                  ¥13,000
                </span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xs md:text-sm">・ミニポーチ（会場別）</span>
                <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                  各¥1,500
                </span>
              </div>
              <div className="flex items-start gap-3">
                <span className="hidden md:inline text-xs md:text-sm">
                  ・巻きつけろ！オーロラバンド（会場別）
                </span>
                <span className="md:hidden text-xs">
                  ・巻きつけろ！オーロラバンド<br />
                  （会場別）
                </span>
                <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                  各¥1,200
                </span>
              </div>
              <div className="flex items-start gap-3">
                <span className="hidden md:inline text-xs md:text-sm">
                  ・MOKU×UUUコラボタオル（会場別）
                </span>
                <span className="md:hidden text-xs">
                  ・MOKU×UUUコラボタオル<br />
                  （会場別）
                </span>
                <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                  各¥1,500
                </span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-xs md:text-sm">・何が出るかな？お楽しみアイテム</span>
                <span className="text-xs md:text-sm text-[#fcb122] font-bold whitespace-nowrap">
                  ¥500
                </span>
              </div>
            </div>
          </div>

          {/* 注意事項 */}
          <div className="bg-[#1a1a3e]/80 border-2 border-[#44c4ff]/50 px-6 py-4 mt-6">
            <p className="text-xs md:text-sm text-white/70">
              ※お一人様1会計につき、各商品3点までご購入いただけます。<br />
              ※表示価格はすべて消費税込です。<br />
              ※商品ラインナップは、追加・変更等の可能性がございます。あらかじめご了承ください。<br />
              ※会場別商品は会場毎にデザイン共通でカラーが異なります。
            </p>
          </div>
        </div>

        {/* 事前通販スケジュール */}
        <div className="bg-gradient-to-r from-[#1a1a3e] to-[#2a2a4e] border-2 border-[#fcb122]/50 p-6 md:p-8 mb-8">
          <h3 className="text-xl md:text-2xl text-[#fcb122] font-bold mb-4 text-center">
            事前通販スケジュール
          </h3>
          <div className="text-center">
            <p className="hidden md:block text-base text-white/90 mb-4">
              <span className="text-[#fcb122] font-bold">【受付期間】</span>2月2日(月)18:00～3月2日(月)23:59
            </p>
            <p className="md:hidden text-sm text-white/90 mb-4">
              <span className="text-[#fcb122] font-bold">【受付期間】</span><br />
              2月2日(月)18:00～<br />
              3月2日(月)23:59
            </p>
            <p className="text-xs md:text-sm text-white/70 mb-6">
              ※販売上限数に達した場合、受付期間中であっても受付終了致します。あらかじめご了承ください。
            </p>
            
            <span className="inline-block bg-gray-600 text-gray-400 font-bold text-sm md:text-base px-8 md:px-12 py-3 md:py-4 rounded-full cursor-not-allowed whitespace-nowrap">
              <i className="ri-shopping-cart-2-line mr-2"></i>
              受付終了
            </span>
          </div>
        </div>

        {/* 会場販売について */}
        <div className="bg-gradient-to-r from-[#1a1a3e] to-[#2a2a4e] border-2 border-[#1ef99d]/50 p-6 md:p-8">
          <h3 className="text-xl md:text-2xl text-[#1ef99d] font-bold mb-4 text-center">
            会場販売について
          </h3>
          <div className="text-center space-y-4">
            <p className="text-sm md:text-base text-white/90">
              販売場所、販売スケジュールの詳細は決まり次第、お知らせいたします。
            </p>
            <p className="text-xs md:text-sm text-white/70">
              ※十分な在庫数をご用意しておりますが、商品の数に限りがございます。あらかじめご了承ください。<br />
              ※会場販売の個数制限は変更になる場合がございます。<br />
              ※本公演のグッズは、お客様のお手元に商品をお届けする「事前通販」と、各公演の会場にて実施予定の「当日販売」にてご購入いただけます。<br />
              ※事前通販グッズは各公演での会場物販でも販売致します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}